__turbopack_context__.v({
  "bannerCaption": "styleConstants-module__ptgU4G__bannerCaption",
  "bannerSubtitle": "styleConstants-module__ptgU4G__bannerSubtitle",
  "bannerTitle": "styleConstants-module__ptgU4G__bannerTitle",
  "sectionWrapper": "styleConstants-module__ptgU4G__sectionWrapper",
});
